import { usePeriod } from '../contexts/PeriodContext';
import { formatPeriodLabel } from '../utils/formatPeriodLabel';
import { Select } from './ui/select';

export default function PeriodSelector() {
  const { periods, selectedPeriod, setSelectedPeriod, loading } = usePeriod();

  if (loading) {
    return (
      <div className="flex items-center gap-3">
        <label htmlFor="period-selector" className="text-sm text-foreground">Period:</label>
        <div className="px-3 py-1.5 text-sm text-muted-foreground bg-secondary rounded-md border border-border">
          Loading periods...
        </div>
      </div>
    );
  }

  if (periods.length === 0) {
    return (
      <div className="flex items-center gap-3">
        <label htmlFor="period-selector" className="text-sm text-foreground">Period:</label>
        <div className="px-3 py-1.5 text-sm text-muted-foreground bg-secondary rounded-md border border-border">
          No periods available
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3">
      <label htmlFor="period-selector" className="text-sm text-foreground">Period:</label>
      <Select
        id="period-selector"
        value={selectedPeriod}
        onChange={(e) => setSelectedPeriod(e.target.value)}
        options={periods.map((period) => ({
          value: period,
          label: formatPeriodLabel(period),
        }))}
      />
    </div>
  );
}

